(() => {
  const mobileShyGuys = document.querySelectorAll(".js-swatch-input-item--hide-mobile");
  const desktopShyGuys = document.querySelectorAll(".js-swatch-input-item--hide-desktop");

  const mobileActivator = document.querySelector(".js-swatch-input__too-much--mobile");
  const desktopActivator = document.querySelector(".js-swatch-input__too-much--desktop");

  if (mobileActivator != null) {
    mobileActivator.addEventListener("click", (e) => {
      Array.from(mobileShyGuys).forEach((shyGuy) => {
        shyGuy.classList.remove("swatch-input-item--hide-mobile");
      });
      mobileActivator.classList.add("hidden");
      mobileActivator.classList.add("clicked");
    });

    if (mobileActivator.classList.contains("clicked")) {
      mobileActivator.click();
    }
  }

  if (desktopActivator != null) {
    desktopActivator.addEventListener("click", (e) => {
      Array.from(desktopShyGuys).forEach((shyGuy) => {
        shyGuy.classList.remove("swatch-input-item--hide-desktop");
      });
      desktopActivator.classList.add("hidden");
      desktopActivator.classList.add("clicked");
    });

    if (desktopActivator.classList.contains("clicked")) {
      desktopActivator.click();
    }
  }
})();
